import enclomiphene from './intial/flow';
import enclomipheneFollowup from './followup/flow';

const EnclomipheneFlows = {
  enclomiphene,
  enclomipheneFollowup
};

export default EnclomipheneFlows;
